import { useAiAvailability } from '../../hooks/useAiAvailability';
import { ImageAnalysisAuthority } from '../../services/imageAnalysisService';
import { InfoIcon } from './icons';
import { useState } from 'react';
import { ClickAwayListener, IconButton, Tooltip } from '@mui/material';

const AI_CREDIT_COST = 'Uses 1 credit per image.';
export const AI_CREDIT_TOOLTIP = `${AI_CREDIT_COST} Reusing saved keywords is free.`;

export function AiCreditTooltip({
  description,
  authority,
  freeUses,
  label = 'Credit cost',
  showPreviouslyAnalysedNote = true,
}: {
  description?: string;
  authority?: ImageAnalysisAuthority;
  freeUses?: number;
  label?: string;
  showPreviouslyAnalysedNote?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const ai = useAiAvailability(open && Boolean(authority), authority);
  const remaining = ai.capability?.freeAiUses ?? freeUses ?? 0;
  const cost = showPreviouslyAnalysedNote ? AI_CREDIT_TOOLTIP : AI_CREDIT_COST;
  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        title={
          remaining > 0
            ? `${remaining} free uses remaining`
            : description
              ? `${description} ${cost}`
              : cost
        }
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        disableTouchListener
        describeChild
      >
        <IconButton
          size="small"
          aria-label={label}
          onClick={() => setOpen(true)}
          onFocus={() => setOpen(true)}
          onBlur={() => setOpen(false)}
          disableRipple
          sx={{
            boxShadow: 'none',
            backgroundColor: 'transparent',
            '&:hover': { backgroundColor: 'transparent' },
          }}
          onKeyDown={(event) => {
            if (event.key === 'Escape') setOpen(false);
          }}
        >
          <InfoIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </ClickAwayListener>
  );
}
